import "./OcrScreenComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {useDispatch} from "react-redux";
import commonService from "../../shared/services/common.service";
import {IAPIResponseType} from "../../shared/models/api.model";
import ENV from "../../constants/ENV";
import LottieFileGenarationComponent
    from "../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../constants";
import {OCR_LAST_URL} from "../../constants/Misc";

interface OcrComponentProps {

}

const OcrScreenComponent = (props: OcrComponentProps) => {

    const dispatch = useDispatch();
    const [token, setToken] = useState<any>(undefined);
    const [iframeLoading, setIframeLoading] = useState<boolean>(true);
    // const [tokenLoading, setTokenLoading] = useState<boolean>(false);
    // const [tokenLoadingFailed, setTokenLoadingFailed] = useState<boolean>(false);
    const localStorageOcrLastURl= (!commonService._localStorage.getItem(OCR_LAST_URL) || commonService._localStorage.getItem(OCR_LAST_URL) === "{}") ?
        ENV.OCR_UI_URL : commonService._localStorage.getItem(OCR_LAST_URL);

    const [ocrURL, setOcrURL] = useState<any>(localStorageOcrLastURl);
    const [tokenLoaded, setTokenLoaded] = useState<boolean>(false);

    useEffect(() => {
        dispatch(setCurrentNavParams("OCR Billing", "OCR Billing"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const getTokenForOcr = useCallback(() => {
        const payload = {
            "userId": 1,
            "secreteKey": "123456789012"
        }
        // setTokenLoading(true);
        // setTokenLoadingFailed(false);
        setTokenLoaded(false)
        commonService._user.getOcrToken(payload)
            .then((response: IAPIResponseType<any>) => {
                // setTokenLoading(false);
                // setTokenLoadingFailed(false);
                const currentUrl = localStorageOcrLastURl;
                const urlSearchParams = new URLSearchParams(currentUrl?.split('?')[1]);
                console.log(urlSearchParams);
                urlSearchParams.set('token', response.data.token);
                setOcrURL(`${currentUrl?.split('?')[0]}?${urlSearchParams.toString()}`)
                setTokenLoaded(true)
                setToken(response.data.token);
            })
            .catch((err: any) => {
                // setTokenLoading(false);
                // setTokenLoadingFailed(true);
                commonService._alert.showToast(err.error)
                setTokenLoaded(false)
            })
    }, [localStorageOcrLastURl])

    useEffect(() => {
        getTokenForOcr();
    }, [getTokenForOcr])


    useEffect(() => {
        window.addEventListener('message', handleIframeMessage);
        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, []);

    const handleIframeMessage = (event: any) => {
        console.log('Received message from iframe:', event.data);
        // if (event.origin !== ENV.OCR_UI_URL) return;
        if (event?.data?.source === "OCR-Tericsoft") {
            const currentUrl = event.data.url;
            commonService._localStorage.setItem(OCR_LAST_URL, currentUrl);
        } else {
            return;
        }
    };

    // @ts-ignore
    return (
        <div className={'ocr-screen-component'}>
            {
                tokenLoaded && token && <>
                    {
                        iframeLoading && <div className="h-v-center">
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.LoadingLottieFile}/>
                        </div>
                    }
                    <iframe
                        // @ts-ignore
                        src={ocrURL}
                        // src={`http://192.168.0.7:3005?token=${token}`}
                        className={'ocr-iframe'}
                        width="100%"
                        height="100%"
                        title={'OCR'}
                        loading={'eager'}
                        onLoad={() => setIframeLoading(false)}
                    />
                </>
            }
        </div>
    );

};

export default OcrScreenComponent;
